module.exports = __webpack_public_path__ + "img/real-time03.eadeddaa.jpg";